import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { statusMap } from "../helper";
import FeedbackCard from "../../../components/feedback/feedbackCard";
import { useGetAllFeedbacksQuery, useGetFeedbackCategoriesQuery } from "../../../redux/slices/feedbackApiSlice";
import { CustomLoader, H1Header } from "../../../components";

const Feedbacks = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Fetch categories
  const { data: categories = [], isLoading: loadingCategories } = useGetFeedbackCategoriesQuery();

  // Fetch feedbacks
  const { data: feedbacks = [], isLoading: loadingFeedbacks } = useGetAllFeedbacksQuery({});

  const [likes, setLikes] = useState(
    feedbacks.reduce((acc, feedback) => ({ ...acc, [feedback.title]: feedback.likes }), {})
  );

  const sortFeedbacks = (status) => {
    return feedbacks
      .filter((f) => f.status === status)
      .sort((a, b) => b.likes - a.likes || new Date(b.status_changed_at) - new Date(a.status_changed_at));
  };

  return (
    <>
      <Helmet>
        <title>{t("Feedbacks-and-roadmap", "Feedbacks et roadmap")} | BotBlogR</title>
        <meta name="description" content="Page de feedbacks." />
      </Helmet>

      <div className="px-2 pl-6 pr-6">
        {/* Titre */}
        <div className="flex items-center justify-center py-3">
          <H1Header title={t("Feedbacks-and-roadmap", "Feedbacks et roadmap")} />
        </div>
        <p className="text-gray-600 text-center mb-8">
            Voir les mises à jour à venir, demander la création d'une nouvelle fonctionnalité ou reporter un bug : cet espace est fait pour ça !
        </p>

        {/* Catégories */}
        <div className="mb-10">
            <h2 className="text-xl">Catégories de feedbacks</h2>
            {loadingCategories ? (
              <div className='flex justify-center'><CustomLoader /></div>
            ) : (
              <div className="grid grid-cols-3 gap-4 my-6">
                {categories.map((cat) => (
                  <div
                    key={cat.key}
                    className="flex justify-between items-center p-4 bg-white border border-black/30 rounded-lg cursor-pointer hover:bg-black/5"
                    onClick={() => navigate(`/feedbacks/list?category=${cat.key}`)}
                  >
                    <span className="font-semibold">{cat.name}</span>
                    <span className="bg-gray-300 text-gray-700 px-3 py-1 rounded-full">{cat.count}</span>
                  </div>
                ))}
              </div>
            )}
        </div>

        {/* Roadmap */}
        <div className="mb-10">
          <h2 className="text-xl">Roadmap</h2>
          <div className="grid grid-cols-3 gap-4 my-6">
            {Object.entries(statusMap).map(([status, { title, color }]) => (
              status !== "suggested" &&
              <div key={status} className="bg-white border-black/30 border rounded-lg shadow">
                {/* Header with title and color indicator */}
                <div className="flex items-center pb-3 border-black/30 border-b p-4">
                    <span className={`w-3 h-3 rounded-full ${color} mr-2`}></span>
                    <h2 className="font-semibold">{title}</h2>
                </div>
                {/* Content section with fixed height and scroll */}
                <div className="mt-3 min-h-14 max-h-80 overflow-y-auto px-4 py-2">
                  {loadingFeedbacks ? (
                    <div className='flex justify-center'><CustomLoader /></div>
                  ) : (
                    sortFeedbacks(status).length > 0 ? (
                      sortFeedbacks(status).map((fb) => (
                        <FeedbackCard key={fb.id} feedback={fb} />
                      ))
                    ) : (
                      <div className="text-center text-gray-500">Aucun feedback pour le moment</div>
                    )
                  )}
              </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </>
  );
};

export default Feedbacks;
